import MembershipsContainer from './MembershipsContainer';

export default MembershipsContainer;
